<template>
  <v-container fluid class="px-0 py-0 mx-0">
    <v-layout row wrap>
      <v-flex xs12>
          <viewer :options="options" :images="product.pictures"
          @inited="inited"
          class="viewer" ref="viewer"
          >
        <!--<v-card>-->
        <!--<v-card-media :src="product.pictures[0]" height="400px">
          </v-card-media>-->
        <v-carousel v-if="product.pictures.length > 0" hide-controls>
          <v-carousel-item v-for="(item,i) in product.pictures" :src="item" :key="i" v-on:click.native="show()"></v-carousel-item>
        </v-carousel>
        <v-carousel v-else hide-controls>
          <v-carousel-item src="./../assets/camera_background.png"></v-carousel-item>
        </v-carousel>
        <!--</v-card>-->
          </viewer>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <p class="mb-0 font-600">Descripcion</p>
                <p>{{ product.description }}</p>
              </v-flex>
              <v-flex xs6>
                <p class="mb-0 font-600">Notas</p>
                <p>{{ product.notes }}</p>
              </v-flex>
              <v-flex xs6>
                <p class="mb-0 font-600">Categoria</p>
                <p>{{ product.category.name }}</p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout>
      <v-flex xs12>
        <v-card flat>
          <v-container class="px-0 py-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-list two-line>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <img v-if="owner.picture !== ''" :src="owner.picture">
                      <img v-else src="./../assets/default_image_profile.png">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="owner.organization" class="font-600"></v-list-tile-title>
                      <v-list-tile-sub-title class="font-600">
                          <a :href="'mailto:' + owner.email + '?subject=Ilewasi Producto ' + product.title + '&body=Interesado en el producto ' + product.title +'.'">{{ owner.email }}</a>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-list-tile-action-text class="pb-3">{{ date }}</v-list-tile-action-text>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import HTTP from '@/axios-config'

import Viewer from 'v-viewer/src/component.vue'

export default {
  components: {
    Viewer
  },
  name: 'Product',
  data () {
    return {
      owner: {
        picture: '',
        organization: '',
        address: ''
      },
      date: '',
      product: {
        pictures: [],
        description: '',
        notes: '',
        category: {}
      },
      options: { 'inline': false, 'button': false, 'navbar': true, 'title': false, 'toolbar': false, 'tooltip': false, 'movable': false, 'zoomable': false, 'rotatable': false, 'scalable': false, 'transition': true, 'fullscreen': true, 'keyboard': false, 'url': 'data-source' }
    }
  },
  created () {
    this.product = this.$store.getters.getProduct
    this.date = this.formatDate(new Date(this.product.modifiedAt))
    this.getOwner()
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer
    },
    show () {
      this.$viewer.show()
    },
    formatDate (date) {
      var monthNames = [
        'Enero', 'Febrero', 'Marzo',
        'Abril', 'Mayo', 'Junio', 'Julio',
        'Agosto', 'Septiembre', 'Octubre',
        'Noviembre', 'Diciembre'
      ]

      var day = date.getDate()
      var monthIndex = date.getMonth()
      var year = date.getFullYear()

      return day + ' ' + monthNames[monthIndex] + ' ' + year
    },
    getOwner () {
      HTTP.get('/user/get/' + this.product.owner)
        .then(function (response) {
          this.owner = response.data.result
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    }
  }
}

</script>

<!-- Add "scoped " attribute to limit CSS to this component only -->
<style>
  .font-600 {
    font-weight: 600 !important;
  }

  .carousel {
    height: auto !important;
  }

  .carousel__controls {
    background-color: transparent !important;
  }

  .jumbotron__image {
    width: 100% !important;
    height: 100% !important;
    max-height: 400px !important;
    object-fit: cover !important;
    position: unset !important;
    left: 50% !important;
    -webkit-transform: none !important;
    transform: none !important;
    min-width: 100% !important;
    will-change: transform !important;
    -webkit-transition: none !important;
    transition: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Product.vue